import React, { useState, useContext } from 'react';
import StepComponent from './StepComponent';
import FinishProject from './FinishProject';
import { ProjectContext } from '../contexts/Project';
import steps from '../steps';
import '../styles/ProjectForm.css'; // Імпорт CSS стилів


const ProjectForm = ({ projectId, user}) => {
    const {toggleAdvice} =useContext(ProjectContext)
    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState({});


    function deleteEmptyFields(obj) {
        for (let key in obj) {
            if (obj[key] === "" || obj[key] === null || obj[key] === undefined || (Array.isArray(obj[key]) && obj[key].length === 0)) {
              delete obj[key];
            }
          }
    }
    // Навігація між кроками
    const nextStep = () => {
         // Якщо користувач створив пусте поле видаляємо його 
        deleteEmptyFields(formData)
          if(Object.keys(formData).length >= currentStep+1) {
            setCurrentStep((prev) => Math.min(prev + 1, steps.length))
            toggleAdvice(false)
        }

    };
    const prevStep = () => {
        // Якщо користувач створив пусте поле видаляємо його 
        deleteEmptyFields(formData)
        if(Object.keys(formData).length >= currentStep) {
        setCurrentStep((prev) => Math.max(prev - 1, 0))
        toggleAdvice(false)
        }
    };
   
    return (
               <div className="project-form-page">
 {currentStep === steps.length ? (
            <FinishProject data={formData} user={user} id={projectId} /> // Рендер іншого компонента
        ) :
        <div>
            <StepComponent
                step={steps[currentStep]}
                data={formData}
                setData={setFormData}
            />
            <div className="navigation-buttons">
                <button onClick={prevStep} disabled={currentStep === 0}>
                    Назад
                </button>
                <button onClick={nextStep} disabled={currentStep === steps.length}>
               { currentStep === steps.length-1?  'Зберігти': 'Далі'}
                </button>
            </div>
</div> }
        </div>
    );
};

export default ProjectForm;